import React from "react";
import { VariantProps } from ".";
import PlusShippingLevels from "../PlusShippingLevels";
import GoogleViewPrice from "../GoogleViewPrice";
import StandardPrice from "../StandardPrice";

const Z = ({
  hasWebPlusDiscountedShipping,
  allowWebPlusDiscountedShipping,
  price,
  isGoogleView,
  minimumBuy,
  mustBuy,
  unitOfMeasure,
  isWebstaurantPlusEligible,
  user,
}: VariantProps) => {
  return (
    <>
      <label>Each Only</label>
      {isGoogleView ? (
        <GoogleViewPrice
          price={price.price}
          minimumBuy={minimumBuy}
          mustBuy={mustBuy}
        />
      ) : (
        <StandardPrice price={price.price} unitOfMeasure={unitOfMeasure} />
      )}
      <PlusShippingLevels
        hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping}
        allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping}
        isWebstaurantPlusEligible={isWebstaurantPlusEligible}
        user={user}
      />
    </>
  );
};

export default Z;
